export default __webpack_public_path__ + "static/media/slot-banner.9dda7c86.png";